module.exports = __webpack_public_path__ + "static/wishstring-a5c4bba9451f687df9abbd7649626d25.jpeg";